import { useEffect } from 'react';
import { ensureCertificate } from '../../utils/secure/fetch-certificate';

/**
 * Fetches the server's public certificate once, as early as possible.
 *
 * Rendered inside `PersistGate` (see `src/redux/Store.jsx`) for two reasons:
 *   1. The redux store global exists by then, so the fetch can dispatch.
 *   2. redux-persist has finished rehydrating. Dispatching before rehydration
 *      completes would let the REHYDRATE action overwrite the certificate we
 *      just stored with the older persisted value.
 *
 * It renders nothing and never blocks the UI. API calls made while the fetch is
 * in flight are not delayed — they use the certificate rehydrated from the
 * previous visit, and only a genuine first-ever visit waits for this fetch (see
 * `afterCertificate` in `utils/api/secure-client.js`).
 */
export default function CertificateBootstrap() {
  useEffect(() => {
    ensureCertificate();
  }, []);

  return null;
}
